import React from "react";
import { Skeleton } from "components";

export default function Paragraph({ rows = 10 }) {
  return (
    <div>
      {Array(rows)
        .fill((i) => i)
        .map((_, index) =>
          rows > 1 && index === rows - 1 ? (
            <Skeleton count={1} height={10} width={"10%"} />
          ) : (
            <Skeleton count={1} height={10} width={"100%"} />
          )
        )}
    </div>
  );
}
